import { render, staticRenderFns } from "./SpellEditor.vue?vue&type=template&id=29bc8a53&scoped=true&"
import script from "./SpellEditor.vue?vue&type=script&lang=js&"
export * from "./SpellEditor.vue?vue&type=script&lang=js&"
import style0 from "./SpellEditor.vue?vue&type=style&index=0&id=29bc8a53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bc8a53",
  null
  
)

export default component.exports